<form [formGroup]="paramFormExtV5" *ngIf="!readOnly">
  <mat-form-field>
    <input matInput placeholder="ParamA" formControlName="paramA" required type="number">
  </mat-form-field>
  <mat-form-field>
    <input matInput placeholder="ParamB" formControlName="paramB" required type="number">
  </mat-form-field>
  <mat-form-field>
    <input matInput placeholder="ParamC" formControlName="paramC" required type="number">
  </mat-form-field>
  <mat-form-field>
    <input matInput placeholder="ParamD" formControlName="paramD" required type="number">
  </mat-form-field>
  <mat-form-field>
    <input matInput placeholder="ParamE" formControlName="paramE" required type="number">
  </mat-form-field>
</form>

<form *ngIf="readOnly">

    <mat-form-field class="readonly">
        <input matInput placeholder="ParamA" [value]="paramFormExtV5.value.paramA" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="readonly">
        <input matInput placeholder="ParamB" [value]="paramFormExtV5.value.paramB" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="readonly">
        <input matInput placeholder="ParamC" [value]="paramFormExtV5.value.paramC" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="readonly">
        <input matInput placeholder="ParamD" [value]="paramFormExtV5.value.paramD" [readonly]="true">
    </mat-form-field>
    <mat-form-field class="readonly">
        <input matInput placeholder="ParamE" [value]="paramFormExtV5.value.paramE" [readonly]="true">
    </mat-form-field>

</form>